import React, { FC } from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import media from '../../../constants/media';
import theme from '../../../constants/theme';
import { IFormSelectOption } from '../../../interfaces/forms/forms';

interface Props {
	id: string;
	options: IFormSelectOption[];
	onChange: any;
	onBlur: any;
	name: string;
	value: IFormSelectOption;
	placeholder?: string;
	disabled?: boolean;
	styles?: any;
	autocomplete?: string;
	searchFunction?: (data: any, searchString: string) => boolean;
	// id given to the inner input element, so callers can focus the select programmatically.
	inputId?: string;
}

const Wrapper = styled.div`
	font-size: 2rem;
	${media.tablet`
		font-size: 1.7rem;
	`};
`;

export const selectStyles = {
	control: (provided, state) => ({
		...provided,
		display: 'flex',
		justifyContent: 'space-between',
		height: '5rem',
		width: '100%',
		padding: '0 1.2rem',
		border: `1px solid ${state.isFocused ? theme.colors.primary : theme.colors.borderColor}`,
		boxShadow: state.isFocused ? `0 2px 6px ${theme.colors.primary}33` : 'none',
		'&:hover': {
			borderColor: theme.colors.primary,
		},
	}),
	placeholder: provided => ({
		...provided,
		color: theme.colors.textDarker,
	}),
	dropdownIndicator: provided => ({
		...provided,
		color: theme.colors.primary,
	}),
	indicatorSeparator: () => ({}),
	singleValue: provided => ({
		...provided,
		color: theme.colors.textDarker,
	}),
	// Options wrap on spaces but never break a word mid-character; an unbreakable word too wide
	// for the dropdown is clipped rather than causing horizontal scroll.
	menuList: provided => ({
		...provided,
		overflowX: 'hidden',
	}),
	option: provided => ({
		...provided,
		whiteSpace: 'normal',
		wordBreak: 'normal',
		overflowWrap: 'normal',
		overflow: 'hidden',
	}),
};

const FormikSelect: FC<Props> = ({
	id,
	options,
	onChange,
	onBlur,
	name,
	value,
	placeholder,
	disabled,
	styles,
	searchFunction,
	autocomplete,
	inputId,
}) => {
	const handleChange = (option: IFormSelectOption) => {
		onChange(name, option);
	};

	const handleBlur = () => {
		onBlur(name, true);
	};

	return (
		<Wrapper>
			<Select
				id={id}
				inputId={inputId}
				name={autocomplete || name}
				options={options}
				onChange={handleChange}
				onBlur={handleBlur}
				placeholder={placeholder}
				isDisabled={disabled === true}
				styles={styles || selectStyles}
				value={value}
				// @ts-ignore
				autocomplete={autocomplete}
				filterOption={searchFunction}
				inputProps={{ readOnly: true }}
			/>
		</Wrapper>
	);
};

export default FormikSelect;
